import { IParseOptions, IStringifyOptions } from 'qs';

export const decoder: IParseOptions['decoder'] = (str: string, defaultDecoder) => {
  try {
    return JSON.parse(str);
  } catch (error) {
    return defaultDecoder(str);
  }
};

export const encoder: IStringifyOptions['encoder'] = (value: string) => {
  if (typeof value === 'string') {
    return value.trim();
  }

  return value;
};

export const filterEmpty = (_prefix: string, value: unknown) => {
  if (value === null || value === undefined || value === '') {
    return {};
  }

  return value;
};
